var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8704 9.02966C29.4395 11.6535 30.1099 14.724 29.7788 17.7691V19.5169C29.7767 21.3572 30.2555 23.1657 31.1667 24.7605M8.9605 16.0212C8.9605 14.1669 9.6916 12.3886 10.993 11.0774C12.2944 9.76627 14.0595 9.02966 15.8999 9.02966C17.7404 9.02966 19.5054 9.76627 20.8068 11.0774C22.1082 12.3886 22.8392 14.1669 22.8392 16.0212V17.7691C22.8392 21.551 24.0568 25.2309 26.3091 28.2563M15.8999 16.0212V19.5169C15.8944 24.5148 17.4079 29.3945 20.2371 33.5M8.9605 23.0127C9.38502 26.6654 10.4419 30.2149 12.0832 33.5M3.58244 30.0042C2.41183 26.0371 1.88459 21.9056 2.02107 17.7691V16.0212C2.01442 13.5634 2.65086 11.1473 3.86627 9.01629C5.08168 6.8853 6.8331 5.1147 8.94409 3.88291C11.0551 2.65112 13.451 2.00167 15.8904 2C18.3299 1.99834 20.7267 2.64451 22.8395 3.87341",
    stroke: "#353535",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV5);
export default __webpack_public_path__ + "static/media/v5.3ed57ded6f3c64e3723a0c5f0ce25ed7.svg";
export { ForwardRef as ReactComponent };